let locks = 0;
let restorePage;

// overflow:hidden alone still permits iOS viewport panning. Freeze the document
// while allowing only scrollable dialog content to consume vertical gestures.
export function lockDialogPage() {
  if (locks++ === 0) {
    const body = document.body;
    const route = window.location.pathname + window.location.search;
    const x = window.scrollX,
      y = window.scrollY;
    const names = ['position', 'top', 'left', 'right', 'width', 'overflow'];
    const before = names.map((name) => [
      name,
      body.style.getPropertyValue(name),
      body.style.getPropertyPriority(name),
    ]);
    Object.assign(body.style, {
      position: 'fixed',
      top: `${-y}px`,
      left: `${-x}px`,
      right: '0',
      width: '100%',
      overflow: 'hidden',
    });
    let startX = 0,
      startY = 0;
    const start = (e) => {
      if (e.touches.length === 1) {
        startY = e.touches[0].clientY;
        startX = e.touches[0].clientX;
      }
    };
    const move = (e) => {
      if (e.touches.length !== 1) return;
      const dy = e.touches[0].clientY - startY,
        dx = e.touches[0].clientX - startX;
      startY = e.touches[0].clientY;
      startX = e.touches[0].clientX;
      if (Math.abs(dx) > Math.abs(dy)) return;
      let node = e.target instanceof Element ? e.target : e.target?.parentElement;
      const dialog = node?.closest('[role="dialog"], [role="alertdialog"]');
      while (node && dialog?.contains(node)) {
        const overflow = getComputedStyle(node).overflowY;
        if (
          /(auto|scroll)/.test(overflow) &&
          node.scrollHeight > node.clientHeight + 1 &&
          ((dy < 0 && node.scrollTop + node.clientHeight < node.scrollHeight - 1) ||
            (dy > 0 && node.scrollTop > 0))
        )
          return;
        node = node.parentElement;
      }
      if (e.cancelable) e.preventDefault();
    };
    document.addEventListener('touchstart', start, { passive: true });
    document.addEventListener('touchmove', move, { passive: false });
    restorePage = () => {
      document.removeEventListener('touchstart', start);
      document.removeEventListener('touchmove', move);
      for (const [name, value, priority] of before) {
        if (value) body.style.setProperty(name, value, priority);
        else body.style.removeProperty(name);
      }
      if (
        route === window.location.pathname + window.location.search &&
        (window.scrollX !== x || window.scrollY !== y)
      )
        window.scrollTo({ left: x, top: y, behavior: 'instant' });
    };
  }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--locks === 0) {
      restorePage?.();
      restorePage = null;
    }
  };
}
